import { default as KeyboardZoom } from 'ol/interaction/KeyboardZoom';
import { default as RBaseInteraction } from './RBaseInteraction';
/** Zoom with +/- keys on the keyboard */
class RKeyboardZoom extends RBaseInteraction {
    createOL(props) {
        this.classProps = RKeyboardZoom.classProps;
        return new KeyboardZoom(Object.keys(props)
            .filter((p) => this.classProps.includes(p))
            .reduce((ac, p) => (Object.assign(Object.assign({}, ac), { [p]: props[p] })), {}));
    }
}
RKeyboardZoom.classProps = ['condition', 'duration', 'delta'];
export default RKeyboardZoom;
//# sourceMappingURL=RKeyboardZoom.js.map